import React from 'react';
import { FileImport } from './FileImport';
import { useSelector } from 'react-redux';
import { getCompany, getUserRole } from '../../../../../../../redux/selectors';
import { checkIfFileImportEnabled } from '../../../../../../../common/helpers/company';

export const ScheduleFileImport: React.FC = () => {
  const company = useSelector(getCompany);

  const isFileImportEnabled = checkIfFileImportEnabled(company);
  const userRoles = useSelector(getUserRole);

  return (
    <div style={{ marginLeft: '10px' }}>
      {userRoles?.includes('admin') && isFileImportEnabled && <FileImport />}
    </div>
  );
};
